module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./node_modules/deepcopy/index.js
// module id = 33
// module chunks = 0